import { useFrameHooks } from '@xingternal/hub';

const useSpecificExperimentTrackingData = experimentTrackingId => {
  const { useExperimentTrackingData } = useFrameHooks();
  const trackingData = useExperimentTrackingData();

  const propExperimentArray = (trackingData.PropExperiment || []).split(',');
  const propExperimentInfoArray = (trackingData.PropExperimentInfo || []).split(
    ','
  );

  return {
    ...(propExperimentArray &&
      propExperimentArray.length && {
        PropExperiment: propExperimentArray.find(
          experiment => experiment.indexOf(experimentTrackingId) === 0
        ),
      }),
    ...(propExperimentInfoArray &&
      propExperimentInfoArray.length && {
        PropExperimentInfo: propExperimentInfoArray.find(
          experiment => experiment.indexOf(experimentTrackingId) === 0
        ),
      }),
  };
};

export default useSpecificExperimentTrackingData;
